import React from "react";
import { Helmet } from "react-helmet";

import Header from "../../components/Header";
import WelcomeImage from "../../components/WelcomeImage";
import ImageText1 from "../../components/ImageText1";
import Footer from "../../components/Footer";

import backgroundImage from "../../assets/images/salesnfinance/bg-sales.jpg";
import imageUrl1 from "../../assets/images/salesnfinance/sales-section1.jpg";
import imageUrl2 from "../../assets/images/salesnfinance/sales-section2.jpg";
import ImageText2 from "../../components/ImageText2";
function SalesFinance() {
  const welcomeHeading = "Sales en Finance";

  const imageTextText = (
    <>
      Sales (verkoop) is het proces waarbij producten en/of diensten aan klanten
      worden verkocht met als doel de omzet te verhogen en de winstgevendheid te
      verbeteren. Sales richt zich op het opbouwen en onderhouden van relaties
      met bestaande klanten en het acquireren van potentiële klanten. Hierbij
      ligt de focus op de behoefte van de klant. Finance omvat alles wat te
      maken heeft met geldbeheer, investeringen en de financiële aspecten van
      een organisatie. Het gaat om het optimaliseren van de waarde van de
      organisatie, het garanderen van de liquiditeit en het minimaliseren van
      risico’s. Soms staan binnen een organisatie sales en finance op gespannen
      voet met elkaar. Dit terwijl beide functies elkaar juist kunnen
      versterken. Om als bedrijf te kunnen groeien is het van belang om klanten
      te werven en te behouden die de winstgevendheid versterken en een win-win
      situatie creëren.
    </>
  );

  const imageTextText2 = (
    <>
      DD-Group bewijst zichzelf op dit vlak en beschikt dan ook over de juiste
      expertise om andere bedrijven en ondernemers hierover te adviseren. Een
      analyse van de salesfunnel gekoppeld aan een financiële analyse behoort
      hierbij ook tot de mogelijkheden.
    </>
  );

  return (
    <div>
      <Helmet>
        <title>Sales en Finance</title>
        <meta
          name="description"
          content="Krijg training met DD-Group over veiligheid, brandpreventie en cybersecurity via Play-IT. Voor interne transport- en veiligheidstrainingen kun je contact met ons opnemen, en wij verbinden je met 'The Knowledge' voor het beste aanbod via onze speciale referentie."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <WelcomeImage
          backgroundImage={backgroundImage}
          heading={welcomeHeading}
        />
        <section>
          <ImageText2
            text={imageTextText}
            imageUrl={imageUrl1}
            // backgroundColor="#284B5A"
          />

          <ImageText1
            imageUrl={imageUrl2}
            text={imageTextText2}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default SalesFinance;
